// extracted by mini-css-extract-plugin
export default {"inactiveTab":"qgXtuoJmJzK2QkCKhRi2","activeTab":"tHSAaobAe12INHaBwJ1F"};